























































































































































































import {Component, Vue, Watch} from "vue-property-decorator";
import Footer from "@/views/frame/Footer.vue";
import Header from "@/views/frame/Header.vue";
import store from "@/vuex";


@Component({
  components: {
    Footer, Header
  },
})
export default class Home extends Vue {
  bannerList: any = [{img: `/static/compress-img/home/banner/2-3.png`},{img: `/static/compress-img/home/banner/2-2.png`},{img: `/static/compress-img/home/banner/2-1.png`},]
  list0: any = [
    {
      title1: '12', title15:'年',title2: '专业物流服务',img: `/static/compress-img/home/0-1.png`
    },
    {
      title1: '1600', title15:'家',title2: '企业用户选择',img: `/static/compress-img/home/0-2.png`
    },
    {
      title1: '60', title15:'万',title2: '平台注册用户',img: `/static/compress-img/home/0-3.png`
    },
    {
      title1: '30', title15:'万',title2: '在线物联设备',img: `/static/compress-img/home/0-4.png`
    },
  ]
  list1: any = [
    {
      img: `/static/compress-img/home/2-1.png`,
      title: "网络货运/无车承运",
      subTitle: "全行业需求适配  一站式定制服务",
      content: "帮助物流企业建立高效在线调度、订单全程可溯、多方信息共享的智能物流闭环生态，推动公路货运行业企业降本增效，支持集团化运营，同时赋能企业从系统部署到资质申报全流程。"
    },
    {
      img: `/static/compress-img/home/2-2.png`,
      title: "数智物流",
      subTitle: "渠道全链条管控 运输全过程可视",
      content: "通过整合物流承运商资源，进行线上物流询价招投标，实时监管全物流发运过程，财务运费自动对账结算等，经由集团进行统一管控形成集团化物流管理新模式，提高企业物流管理能力，降低企业运输成本"
    },
    {
      img: `/static/compress-img/home/2-3.png`,
      title: "智能仓储",
      subTitle: "软硬件结合  仓运一体化管理",
      content: "智能仓储实现了从硬件到软件的全矩阵闭环仓储作业管理，通过自动化设备替代繁重的人力作业，支持扫码出入库、在线盘点、库存实时统计、一键查询货物位置等功能，使得作业流程更加自动化、智能化、可视化"
    },
  ]
  list2Title: string = '解决方案'
  list2SubTitle: string = '深挖企业痛点，助力企业信息化转型和升级'
  list2: any = [
    {
      title: '物流管理',
      title1: '物流管理',
      subTitle: '数字化赋能集团物流全局管控\n从订单下达到最终交付，全程透明高效',
      img: '/static/compress-img/home/2/1.png',
      img1: '/static/compress-img/home/2/1-1.png',
      list1: ['数字化赋能集团物流全局管控', '从订单下达到最终交付，全程透明高效'],
      list2: ['供需联动', '全程可视', '多维度、智能化']
    },
    {
      title: '网络货运',
      title1: '网络货运',
      subTitle: '对接各省级监测平台\n符合运输企业实际运营需求',
      img: '/static/compress-img/home/2/2.png',
      img1: '/static/compress-img/home/2/2-1.png',
      list1: ['对接各省级监测平台', '符合运输企业实际运营需求'],
      list2: ['进项合规', '税企直连', '降低运营成本']
    },
    {
      title: '多式联运',
      title1: '多式联运',
      subTitle: '“一单制”数据互联\n联运各方协同联动',
      img: '/static/compress-img/home/2/3.png',
      img1: '/static/compress-img/home/2/3-1.png',
      list1: ['“一单制”数据互联', '联运各方协同联动'],
      list2: ['服务标准', '信息透明', '节约成本']
    },
    {
      title: '设备管理',
      title1: '设备管理',
      subTitle: '设备在线管理，边缘计算\n离线监测、异常自动预警',
      img: '/static/compress-img/home/2/4.png',
      img1: '/static/compress-img/home/2/4-1.png',
      list1: ['设备在线管理，边缘计算', '离线监测、异常自动预警'],
      list2: ['实时数据采集', '数据可视化', '高稳定性']
    },
    {
      title: '生产管理',
      title1: '生产管理',
      subTitle: '发布生产计划、追踪生产进度\n在线作业、采集、存储全链生产数据',
      img: '/static/compress-img/home/2/5.png',
      img1: '/static/compress-img/home/2/5-1.png',
      list1: ['发布生产计划、追踪生产进度', '在线作业、采集、存储全链生产数据'
      ],
      list2: ['高效协同供应链', '智能化管理', '柔性生产流程']
    },
    {
      title: '产品追溯',
      title1: '产品追溯',
      subTitle: '基于工业标识码管理工艺流程\n实现在线作业及全生命周期追溯',
      img: '/static/compress-img/home/2/6.png',
      img1: '/static/compress-img/home/2/6-1.png',
      list1: ['基于工业标识码管理工艺流程', '实现在线作业及全生命周期追溯'],
      list2: ['数据共享', '精准追溯', '全过程管控']
    },
    {
      title: '工业电商',
      title1: '工业电商',
      subTitle: '搭建B2B2C平台级电商门户\n为工业企业提供在线交易和营销推广服务',
      img: '/static/compress-img/home/2/7.png',
      img1: '/static/compress-img/home/2/7-1.png',
      list1: ['搭建B2B2C平台级电商门户', '为工业企业提供在线交易和营销推广服务'],
      list2: ['多渠道与生态化', '覆盖工业产品销售场景', '更精细的管理体系',]
    },
    {
      title: '商品码',
      title1: '商品码',
      subTitle: '基于工业标识码搭建的\n快消商品码管理和溯源平台',
      img: '/static/compress-img/home/2/8.png',
      img1: '/static/compress-img/home/2/8-1.png',
      list1: ['基于工业标识码搭建的','快消商品码管理和溯源平台'],
      list2: ['防伪防串货', '一物一码', '全生命周期追溯']
    },
    {
      title: '物流管理',
      title1: '物流管理',
      subTitle: '数字化赋能集团物流全局管控\n从订单下达到最终交付，全程透明高效',
      img: '/static/compress-img/home/2/1.png',
      img1: '/static/compress-img/home/2/1-1.png',
      list1: ['数字化赋能集团物流全局管控', '从订单下达到最终交付，全程透明高效'],
      list2: ['供需联动', '全程可视', '多维度、智能化']
    },
    {
      title: '网络货运',
      title1: '网络货运',
      subTitle: '对接各省级监测平台\n符合运输企业实际运营需求',
      img: '/static/compress-img/home/2/2.png',
      img1: '/static/compress-img/home/2/2-1.png',
      list1: ['对接各省级监测平台', '符合运输企业实际运营需求'],
      list2: ['进项合规', '税企直连', '降低运营成本']
    },
    {
      title: '多式联运',
      title1: '多式联运',
      subTitle: '“一单制”数据互联\n联运各方协同联动',
      img: '/static/compress-img/home/2/3.png',
      img1: '/static/compress-img/home/2/3-1.png',
      list1: ['“一单制”数据互联', '联运各方协同联动'],
      list2: ['服务标准', '信息透明', '节约成本']
    },
    {
      title: '设备管理',
      title1: '设备管理',
      subTitle: '设备在线管理，边缘计算\n离线监测、异常自动预警',
      img: '/static/compress-img/home/2/4.png',
      img1: '/static/compress-img/home/2/4-1.png',
      list1: ['设备在线管理，边缘计算', '离线监测、异常自动预警'],
      list2: ['实时数据采集', '数据可视化', '高稳定性']
    },
    {
      title: '生产管理',
      title1: '生产管理',
      subTitle: '发布生产计划、追踪生产进度\n在线作业、采集、存储全链生产数据',
      img: '/static/compress-img/home/2/5.png',
      img1: '/static/compress-img/home/2/5-1.png',
      list1: ['发布生产计划、追踪生产进度', '在线作业、采集、存储全链生产数据'
      ],
      list2: ['高效协同供应链', '智能化管理', '柔性生产流程']
    },
    {
      title: '产品追溯',
      title1: '产品追溯',
      subTitle: '基于工业标识码管理工艺流程\n实现在线作业及全生命周期追溯',
      img: '/static/compress-img/home/2/6.png',
      img1: '/static/compress-img/home/2/6-1.png',
      list1: ['基于工业标识码管理工艺流程', '实现在线作业及全生命周期追溯'],
      list2: ['数据共享', '精准追溯', '全过程管控']
    },
    {
      title: '工业电商',
      title1: '工业电商',
      subTitle: '搭建B2B2C平台级电商门户\n为工业企业提供在线交易和营销推广服务',
      img: '/static/compress-img/home/2/7.png',
      img1: '/static/compress-img/home/2/7-1.png',
      list1: ['搭建B2B2C平台级电商门户', '为工业企业提供在线交易和营销推广服务'],
      list2: ['多渠道与生态化', '覆盖工业产品销售场景', '更精细的管理体系',]
    },
    {
      title: '商品码',
      title1: '商品码',
      subTitle: '基于工业标识码搭建的\n快消商品码管理和溯源平台',
      img: '/static/compress-img/home/2/8.png',
      img1: '/static/compress-img/home/2/8-1.png',
      list1: ['基于工业标识码搭建的','快消商品码管理和溯源平台'],
      list2: ['防伪防串货', '一物一码', '全生命周期追溯']
    },
  ]
  content3Title: string = '数字化物流仓储应用服务商'
  content3SubTitle: string = '十数载物流运营经验与技术积累'
  content3ContentTitle1: string = '善于结合中国管理特色'
  content3Content1: string = '将极富前瞻性的管理理念和高科技产品最大化在企业落地。通过快速响应的优质服务，帮助客户提升供应链效率、节约物流成本、增强品牌竞争力。'
  content3ContentTitle2: string = '为客户提供物流运营和网络货运运营指导'
  content3Content2: string = '相比于传统的技术公司，我们更具备丰富的物流实体运营经验、全面的平台技术积累和开发能力、行业领先的网络货运平台建设经验。具备高可拓展性的技术架构、支持多样化的微服务组件、混合部署，基于大数据技术实现精准的数据诊断能力。'
  indexType: number = 1;//1左 2右
  localIndex: number = 0;
  left: number = 0;
  timer1: any = null;
  time1Runing:boolean=true;
  time1MouseIn:boolean=false;
  mounted(){
    this.setTimer()
  }
  setTimer(){
    this.clearTimer();
    this.timer1 = setInterval(() => {
      if (!this.time1Runing){
        return
      }
      this.toRight()
    }, 3000);
  }
  beforeDestroy(){
    this.clearTimer()
  }

  clearTimer(){
    clearInterval(this.timer1);
  }
  clickAndToRight(){
    this.setTimer()
    this.toRight()
  }
  clickAndToLeft(){
    this.setTimer()
    this.toLeft()
  }
  toRight() {
    if (this.$refs.tab){
      if (this.localIndex>=9){
        this.$refs.tab.style.transition = 'none';
        this.localIndex=1;
        this.$refs.tab.style.left = -this.localIndex * 320+'px';
        setTimeout(() => this.toRight(), 0)
      }else{
        this.$refs.tab.style.transition = 'all 0.5s';
        this.localIndex++;
        this.$refs.tab.style.left = -this.localIndex * 320+'px';
      }

    }

  }

  toLeft() {
    if (this.$refs.tab){
      if (this.localIndex<=0){
        this.$refs.tab.style.transition = 'none';
        this.localIndex=8;
        this.$refs.tab.style.left = -this.localIndex * 320+'px';
        setTimeout(() => this.toLeft(), 0)
      }else{
        this.$refs.tab.style.transition = 'all 0.5s';
        this.localIndex--;
        this.$refs.tab.style.left = -this.localIndex * 320+'px';
      }
    }

  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/Home.vue